/* global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { Map, List } from 'immutable';
import isEqual from 'lodash/isEqual';
import { ElementActions } from '../../../actions/element';
import InlineEditor from '../../types/InlineEditor';
import { getComponent } from '../../types/Components';
import { InlineEditorActions } from '../../../actions/inlineEditor';
import { validateAndDispatch } from '../../../helpers/form';
import { currentProjectIdSelector } from '../../../reducers/projects';
import {
  relationshipsSelector,
  elementsRelationshipsSelector,
} from '../../ElementRelationships';

const MultiElementPropertiesSelector = createSelector(
  [
    currentProjectIdSelector,
    elementsRelationshipsSelector,
    relationshipsSelector,
  ],
  (currentProjectId, elementsRelationships, relationships) => ({
    currentProjectId,
    elementsRelationships,
    relationships,
  }),
);

@connect(MultiElementPropertiesSelector)
class MultiElementProperties extends Component {
  static propTypes = {
    currentProjectId: PropTypes.string,
    dispatch: PropTypes.func,
    element: PropTypes.instanceOf(Map),
    elements: PropTypes.instanceOf(List),
    elementsRelationships: PropTypes.instanceOf(Map),
    relationships: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.updateElementPropValue = this.updateElementPropValue.bind(this);
  }

  async updateElementPropValue(elementProp, typeOptions, component) {
    const { currentProjectId, dispatch, elements } = this.props;
    const propKey = Object.keys(elementProp)[0];
    const formUid = propKey;

    // Each component can define their own editSubmit function
    if (component && component.editSubmit) {
      const elementIds = elements.map(e => e.get('id')).toArray();
      await component.editSubmit(
        elementProp,
        dispatch,
        currentProjectId,
        elementIds,
        typeOptions,
      );
      return dispatch(InlineEditorActions.unsetInlineEditState(formUid));
    }

    // Default processing for other components
    const options = {
      props: elementProp,
    };

    const action = ElementActions.updatePropertyMulti(
      elements.map(e => e.get('id')),
      options,
    );
    const validation = {};

    await validateAndDispatch(dispatch, action, validation, {
      field: elementProp.propVal,
    });
    return dispatch(InlineEditorActions.unsetInlineEditState(formUid));
  }

  fieldSet(k, val) {
    const {
      elements,
      elementsRelationships,
      relationships,
      elementIds,
      elementType,
    } = this.props;
    let propertyTypeEditor;
    const uid = k;

    if (val && val.has('_type')) {
      if (val.get('_display') === 'false' || val.get('_display') === false)
        return <div />;
      const TypeComponent = getComponent(val.get('_type'));
      const typeOptions =
        val.has('_typeOptions') && val.get('_typeOptions')
          ? val.get('_typeOptions').toJSON()
          : null;
      const elementValues = elements.map(e => {
        const elementProp = e.getIn(['props', k], '');
        if (TypeComponent && TypeComponent.getPropValue) {
          // const prop = (elementProp && elementProp.toJSON) ? elementProp.toJSON() : elementProp;
          const elementId = e.get('id');
          const providesToConsumesFrom = elementsRelationships.get(elementId);
          return TypeComponent.getPropValue(
            elementProp,
            typeOptions,
            elementId,
            relationships,
            providesToConsumesFrom,
          );
        }
        return elementProp;
      });
      let fieldValue = elementValues.every(v =>
        isEqual(v, elementValues.first()),
      )
        ? elementValues.first()
        : '';
      const currentElementId = fieldValue ? elements.first().get('id') : null;
      if (fieldValue && TypeComponent && TypeComponent.getPropValue) {
        fieldValue = elements.first().getIn(['props', k]);
        // if (!fieldValue.toJSON) fieldValue = Immutable.fromJS(fieldValue);
      }
      const providesToConsumesFrom = elementsRelationships.get(
        currentElementId,
      );
      const customHelpText = val.has('_helptext') ? val.get('_helptext') : null;
      propertyTypeEditor = TypeComponent ? (
        <InlineEditor
          component={TypeComponent}
          currentElementId={currentElementId}
          elementIds={elementIds}
          multiEditElementType={elementType}
          providesToConsumesFrom={providesToConsumesFrom}
          propertyKey={k}
          value={fieldValue}
          form={uid}
          inlineTypeOptions={typeOptions}
          customHelpText={customHelpText}
          onSave={this.updateElementPropValue}
        />
      ) : null;
    }

    return (
      <div key={`${k}-row`} className="form-group my-2 row">
        <label className="col-sm-3 col-form-label" style={{ padding: 0 }}>
          {k}
        </label>
        <div key={k} className="col-sm-9">
          {propertyTypeEditor}
        </div>
      </div>
    );
  }

  buildProperties = () => {
    const { elementType } = this.props;
    const properties = elementType.get('props');

    if (!properties || !properties.size) return <span />;

    return (
      <div>
        {properties
          .sortBy(p => p.get('_order'))
          .map((prop, key) => {
            return <div key={key}>{this.fieldSet(key, prop)}</div>;
          })
          .toArray()}
      </div>
    );
  };

  render() {
    const elementProps = this.buildProperties();
    return (
      <div
        style={{ marginTop: 20, marginLeft: 6, marginBottom: 40 }}
        className="element-props"
      >
        {elementProps}
      </div>
    );
  }
}

export default MultiElementProperties;



// WEBPACK FOOTER //
// ./src/components/RightColumn/MultiElementEdit/MultiElementProperties.js